import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ToolbarService,GroupService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';



@Component({
  selector: 'app-nonconformita',
  templateUrl: './nonconformita.component.html',
  styleUrls: ['./nonconformita.component.css'],
  providers: [DetailRowService,SortService,ToolbarService,GroupService]
})
export class NonconformitaComponent implements OnInit {
  nonconformita:any=[];
  public toolbar: string[];
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.toolbar = ['Search'];
    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
      this.apiService.get('todo/nonconformitadaassegnare',params).subscribe(data => {
        this.nonconformita=data.Result;
      });
    });
  }
  goto(){
    this.router.navigateByUrl('/java/sign/login/LogonServletSign?oper=7'.replace('?','QUESTION').replace('=','UGUAL'));
  }
  
  
  apri(data){
 
   
    let logInfo = JSON.parse(localStorage.getItem("logInfo"));
    let params={
      password:logInfo.password,
      userNamelogin:logInfo.username
    }
  
    
    this.globalService.submitForm('sign/login/LogonServletSign?oper=8&id_nc='+data.id,'POST',params);
   
}

  
}
